import React, { useEffect, useState } from "react";
// import { createStyles, makeStyles, Theme } from "@material-ui/core";
import FormDialog from "../../shared/FormDialog";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { setOpenFacilitySelect } from "../../store/config/configActions";
import { useHistory } from "react-router";
import { EXERCISE_RESERVATION, KRYTY_PAGE, STRZELNICA_PAGE } from "../../Routing/routes";
import { FACILITY } from "../../api/useUrlApi";
import { clearBasket } from "../../store/basket/basketActions";
import "./style.css";

declare const config: { FACILITIES_URL: any[] };

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       display: "flex",
//       "& > *": {
//         marginLeft: theme.spacing(20),
//       },
//     },
//     large: {
//       width: theme.spacing(20),
//       height: theme.spacing(20),
//     },
//     small: {
//       width: theme.spacing(10),
//       height: theme.spacing(10),
//     },
//   })
// );

export const TENIS_TYPE = "tenisType";

const MainPage: React.FC = () => {
  const dispatch = useDispatch();
  const open = useSelector((state: State) => state.config.openSelectFacility);
  const history = useHistory();
  const [isTenisKorty, setIsTenisKorty] = useState(false);

  useEffect(() => {
    if (config) {
      if (config.FACILITIES_URL.length > 0) {
        const facility = sessionStorage.getItem(FACILITY);
        if (!facility) {
          dispatch(setOpenFacilitySelect(true));
        } else {
          history.push(`${EXERCISE_RESERVATION}?facility=${JSON.parse(facility)}`);
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleSelectFacility = (facility: string) => {
    if (facility === "lubinTenis") {
      dispatch(clearBasket());
      sessionStorage.setItem(FACILITY, JSON.stringify(facility));
      setIsTenisKorty(true);
    } else {
      sessionStorage.removeItem(TENIS_TYPE);
      dispatch(setOpenFacilitySelect(false));
      dispatch(clearBasket());
      sessionStorage.setItem(FACILITY, JSON.stringify(facility));
      history.push(`${EXERCISE_RESERVATION}?facility=${facility}`);
    }
  };

  const handleTenis = (tenisType: string) => {
    dispatch(setOpenFacilitySelect(false));
    setIsTenisKorty(false);
    sessionStorage.setItem(TENIS_TYPE, JSON.stringify(tenisType));
    history.push(`${EXERCISE_RESERVATION}?facility=lubinTenis&tenisType=${tenisType}`);
  };

  const handleStrzelnicaKryty = (page: string) => {
    dispatch(setOpenFacilitySelect(false));
    history.push(page);
  };

  return (
    <FormDialog
      open={open}
      title={""}
      onClose={() => {}}
      showTitle={false}
      hideActions
      fullScreen
      hideClose
      backgroundColor={"#1a1a1a"}
    >
      {!isTenisKorty ? (
        <div className="bg" style={{ position: "absolute", top: 0, left: 0, color: "#fff" }}>
          <div className="head">
            <div>
              <img className="logo" src={`${process.env.PUBLIC_URL}/img/rcs.png`} alt={"logo"} />
            </div>
            <h1>Wybierz interesujący Cię obiekt:</h1>
          </div>
          <div className="parent">
            {config.FACILITIES_URL.map((item, index) => (
              <div key={index} className={`div${index + 1}`}>
                <a href="#" onClick={() => handleSelectFacility(item.value)}>
                  <img src={`${process.env.PUBLIC_URL}/img/${item.value}.png`} alt={`${item.name}`}/>
                </a>
              </div>
            ))}
            <div className="div6">
              <a href="#" onClick={() => handleStrzelnicaKryty(STRZELNICA_PAGE)}>
                <img src={`${process.env.PUBLIC_URL}/img/strzelnica.png`} alt={"logo"} />
              </a>
            </div>
            <div className="div7">
              <a href="#" onClick={() => handleStrzelnicaKryty(KRYTY_PAGE)}>
                <img src={`${process.env.PUBLIC_URL}/img/kryte.png`} alt={"logo"}/>
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-tenis" style={{ position: "absolute", top: 0, left: 0, color: "#fff" }}>
          <div className="head">
            <div>
              <img className="logo" src={`${process.env.PUBLIC_URL}/img/rcs.png`} alt={"logo"}/>
            </div>
            <h1>Tenis: </h1>
          </div>
          <div id="wrapper" style={{ textAlign: "center", marginLeft: "25%" }}>
            <div style={{ float: "left", width: "25%" }} onClick={() => handleTenis("korty")}>
              <img src={`${process.env.PUBLIC_URL}/img/kortyTenis.png`} alt={"logo"}/>
            </div>
            <div style={{ float: "left", width: "25%", marginLeft: "25%" }} onClick={() => handleTenis("hala")}>
              <img src={`${process.env.PUBLIC_URL}/img/halaTenis.png`}alt={"logo"} />
            </div>
          </div>
        </div>
      )}
    </FormDialog>
  );
};

export default MainPage;
